export const blockIconsHomeOilBarrel = (
	<span className='material-symbols-outlined'>oil_barrel</span>
);
